<template>

</template>

<script>
    import jwtdecode from 'jwt-decode'
    import { commonApi } from '@/api/common'
    export default {
        data() {
            return {
                routerPam: {
                    code: '',
                    site: '',
                    app_id: ''
                }
            }
        },
        beforeRouteEnter(to, from, next) {
			next(vm => {
                vm.routerPam.code = vm.$EpetJs.Common.getRoute().code ? vm.$EpetJs.Common.getRoute().code : '';
                vm.routerPam.site = vm.$EpetJs.Common.getRoute().site ? vm.$EpetJs.Common.getRoute().site : '';
                vm.routerPam.app_id = vm.$EpetJs.Common.getRoute().app_id ? vm.$EpetJs.Common.getRoute().app_id : '';
                vm.qrCodeLogin()
			})
		},
        methods: {
            // 二维码登录
            qrCodeLogin() {
                this.$EpetJs.Common.ajax('post',commonApi.dingQRCodeLoginUrl,{
                    ...this.routerPam,
                    platform: this.$store.state.platformName
                },{
                    customError: true
                }).then(res => {
                    if(res.data.status_code == 200) {
                        //存储用户相关信息到store
						const userId = jwtdecode(res.data.data.token).user.uid
                        const acId = jwtdecode(res.data.data.token).user.acId
                        const username = jwtdecode(res.data.data.token).user.name
						const expire = jwtdecode(res.data.data.token).exp
						this.$store.commit('changeLoginState', {
							isLogin: true
						})
						this.$store.commit('saveUser', {
							userName: username,
							userId: userId,
							acId: acId
						})
						this.$store.commit('saveToken', {
							token: res.data.data.token,
							refreshToken: res.data.data.refresh_token,
							expire: expire
						})
						//如果有跳转链接，则登录成功之后跳转
						if (this.$route.query.referrer) {
							this.$router.replace(this.$route.query.referrer)
						} else {
							this.$router.replace('/')
						}
                    }else {
                        this.$message.warning(res.data.message+'！ 2s后自动跳转登录页')
                        setTimeout(_=>{
                            this.$router.replace('/login')
                        },2000) 
                    }
                })
            }
        }
    }
</script>